import React, { Component } from 'react';
import API from 'API';
import Loader from 'components/common/Loader';
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class Thanks extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { onStartAgainClicked } = this.props;

        return (<>

            <h2>Thank You</h2>

            <p className="subtitle">
                Your booking has been made. You will receive an email from us shortly with confirmation.
            </p>

            <div className="nav-buttons">

                <button
                    type="button"
                    className="btn ms-auto me-auto"
                    onClick={() => onStartAgainClicked()}
                >
                    Book Another
                </button>

            </div>

        </>);
    }
    
}

export default Thanks;